import React from 'react';
import SubscriptionTemplate from './SubscriptionTemplate';
import { displayMessage } from './wsHelpers';
import { connect } from 'react-redux';
import { deleteEventPoint, updateEventPoint, createEventPoint } from '@/redux/actions';

const WS_EVENTS_BY_HTTP = {
	CREATE: 'event/:eventID/point/POST',
	DELETE: 'event/:eventID/point/:pointID/DELETE',
	UPDATE: 'event/:eventID/point/:pointID/PATCH',
};

const PointsSubscriptions = props => {
	const { socket, currentEventId, updateEventPoint, deleteEventPoint } = props;
	const propsToSend = { ...props };
	delete propsToSend.children;

	const subscribe = () => {
		socket.emit('event/:eventID/point/SUBSCRIBE', { eventID: currentEventId });
	};

	const unsubscribe = () => {
		socket.emit('event/:eventID/point/UNSUBSCRIBE', { eventID: currentEventId });
	};

	const listenForDeletedEventPoint = () =>
		socket.on(WS_EVENTS_BY_HTTP.DELETE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error deleting points', error);
			else {
				deleteEventPoint(data);
				displayMessage('Event Point Deleted');
			}
		});

	const listenForUpdatedEventPoint = () =>
		socket.on(WS_EVENTS_BY_HTTP.UPDATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error updating event point', error);
			else {
				updateEventPoint(data);
				displayMessage('Event Point Updated');
			}
		});

	const listenForCreatedEventPoint = () =>
		socket.on(WS_EVENTS_BY_HTTP.CREATE, payload => {
			const { data, error } = payload;
			if (error) displayMessage('Error Creating Event Point', error);
			else {
				createEventPoint(data);
				displayMessage('Event point created');
			}
		});

	const listeners = () => [
		listenForCreatedEventPoint,
		listenForUpdatedEventPoint,
		listenForDeletedEventPoint,
	];

	return (
		<>
			<SubscriptionTemplate
				{...props}
				sub={subscribe}
				unsub={unsubscribe}
				listeners={listeners()}
				routes={Object.values(WS_EVENTS_BY_HTTP)}
				from="PointsSubscriptions"
			/>
			{React.cloneElement(props.children, propsToSend)}
		</>
	);
};

const msp = ({ ws, auth, events }) => ({
	socket: ws.socket,
	auth0Token: auth.auth0Token,
	currentEventId: events.currentEvent.id,
});

const mdp = dispatch => ({
	deleteEventPoint: eventPoint => dispatch(deleteEventPoint(eventPoint)),
	updateEventPoint: eventPoint => dispatch(updateEventPoint(eventPoint)),
	createEventPoint: eventPoint => dispatch(createEventPoint(eventPoint)),
});

export default connect(msp, mdp)(PointsSubscriptions);
